module.exports = __webpack_public_path__ + "img/table_empty.885371bc.png";